import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import Block from '@vfuk/core-block';
import Heading from '@vfuk/core-heading';
import CtaButtonRow from '../../Elements/CtaButtons';
import { CtaButtonProps } from '../../Elements/CtaButtons/CtaButtonRow';
import {
  infoWrapper,
  infoCard,
  infoImage,
  galleryCSS,
} from './styles/SectionInfo.styles';

type ContentProps = {
  id: string;
  buttons: CtaButtonProps[];
};

export interface SectionInfoProps {
  __typename: string;
  id: string;
  data: {
    /** Section Info Header*/
    name: string;
    /** Section Info Description*/
    summary: {
      summary: string;
    };
    /** Section Info Image */
    image: {
      gatsbyImageData: IGatsbyImageData;
      title: string;
      description: string;
    };
    content: ContentProps[];
  };
}

const SectionInfo = (props: SectionInfoProps) => {
  const { data } = props;
  const { name, summary, image } = data;
  let buttons;
  let buttonRowAlignment;
  const buttonsRows = data?.content?.find(content => content.buttons);

  if (buttonsRows !== undefined) {
    buttons = buttonsRows.buttons;
    buttonRowAlignment = buttonsRows.buttonRowAlignment;
  }

  return (
    <Block css={galleryCSS}>
      <div className="spring">
        <div css={infoWrapper}>
          <div css={infoCard}>
            <Heading text={name} level={4} weight={2} appearance="secondary" />
            <p>{summary.summary}</p>

            <div className="infoCard_button">
              {buttons && (
                <CtaButtonRow
                  buttonRowAlignment={buttonRowAlignment}
                  buttons={buttons}
                />
              )}
            </div>
          </div>
          <GatsbyImage
            image={getImage(image) as IGatsbyImageData}
            css={infoImage}
            alt={image.description || image.title}
          />
        </div>
      </div>
    </Block>
  );
};

export default SectionInfo;
